import React from 'react';

// Numbers
const Svg1 = props => (
  <svg viewBox="0 0 7.84 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140z"
      fill="fill"
    />
  </svg>
);

const Svg2 = props => (
  <svg viewBox="0 0 71.12 140" width="1em" height="1em" {...props}>
    <path
      d="M0 140v-7.42A209.12 209.12 0 0019.46 120c6.3-4.62 12.74-9.38 17.64-14.14a86.55 86.55 0 007.42-8.68 70.35 70.35 0 006-9.38c3.24-6.6 5.62-14.3 5.48-21.58v-5.88c-.14-1.82-.28-3.5-.56-5.46A42.58 42.58 0 0052.22 44a56 56 0 00-5.32-10 82.56 82.56 0 00-5.46-6.86l-2.38-2.8A12.69 12.69 0 0036 21.28l-2.68-2.38-1.54-1.54c-3.08-2.24-6-4.62-9.38-5.88A58.93 58.93 0 0011.9 7.7 37.4 37.4 0 000 7V0h2.38A49.68 49.68 0 0112.6 1.12a17.36 17.36 0 013.08.56l1.26.42 1.54.42 4.2 1.26c.42 0 .56.7 1.26.7l3.5 1.68c2.1 1.12 5.18 2.66 7.14 3.92a43 43 0 014.9 3.36 35.31 35.31 0 014.62 4.06 65 65 0 017.42 9.24A86.1 86.1 0 0157.68 37a54.14 54.14 0 013.92 11.58 86.15 86.15 0 011.4 11.9c.14 1.82.28 4.2.28 6a43.34 43.34 0 01-.28 6 52.21 52.21 0 01-2.8 11.62 90.56 90.56 0 01-4.62 11.2l-.84 1.54a25.82 25.82 0 00-2.38 3.92l-3.78 4.34a147.92 147.92 0 01-17.64 15.68L21.42 128l-7.7 5.46h57.4V140z"
      fill="fill"
    />
  </svg>
);

const Svg3 = props => (
  <svg viewBox="0 0 51.1 140" width="1em" height="1em" {...props}>
    <path
      d="M0 132.72c.56 0 2 .14 2.52.14H4.2A36.72 36.72 0 018 133c1.26 0 3.36-.14 4.62-.28.84 0 1.54-.14 2.38-.14l3.36-.14 3.92-.42a18.25 18.25 0 002.94-.56 14.28 14.28 0 003.92-1.26 22.68 22.68 0 004.76-3.5l.28-.28a27.74 27.74 0 004.9-5.46 34.16 34.16 0 005.46-12.6 27.81 27.81 0 00.7-5.6 24.45 24.45 0 00-1.26-8 10.16 10.16 0 00-1.4-3.5 17.91 17.91 0 01-1.58-3.2 22.52 22.52 0 00-4.48-5.18 27.77 27.77 0 00-5.6-4.2 30.64 30.64 0 00-6.44-2.94C20 74.2 15.4 72.66 11.06 73.08l-5.18.28v-7.28a37.13 37.13 0 0014.56-2 45.06 45.06 0 0011.48-6.58 23.37 23.37 0 004.2-4.06l1.54-1.68 1.54-2.24.56-1 1-2c.14-.42.42-.7.56-1.12a23.89 23.89 0 001.82-5.32 24.83 24.83 0 001-7 26.73 26.73 0 00-.28-2.8 9.14 9.14 0 00-.28-1.54 20.1 20.1 0 00-1-2.24 23.53 23.53 0 00-3.94-5.5c-3.08-3.5-7.14-6-11.34-8.26A67.2 67.2 0 0014.84 8 43.27 43.27 0 005.6 7a53.68 53.68 0 00-5.6.28V0c2.24 0 5.46 0 7.7.14s4.2.28 6.3.56c.28 0 .42.14.7.14a32.8 32.8 0 016.86 1.68 25.72 25.72 0 016.72 2.66 48.76 48.76 0 0111.62 7.56 34.68 34.68 0 018.4 11.48 18 18 0 011.82 7.14 25.42 25.42 0 01-.28 7.28 35.12 35.12 0 01-1.68 6.86 49.86 49.86 0 01-2.1 6.44 28.18 28.18 0 01-2 3.5L42 58.38a28.61 28.61 0 01-5 5 40.46 40.46 0 01-6 3.78l-6.3 2.38s9.38 1.26 14.84 5c3.78 3.08 5.74 6.72 7.7 10.64l.42.84A32.84 32.84 0 0150 93.24a16.43 16.43 0 01.7 3.78l.28 3.64a34.12 34.12 0 01.14 3.78 37 37 0 01-.28 3.78 46.63 46.63 0 01-1.68 7.28c-1.4 4.48-3.22 9.66-6.58 13.44s-8.12 6.44-12.74 8.12a48.26 48.26 0 01-7.14 1.82 66.47 66.47 0 01-7.42.7l-7.28.28a7.89 7.89 0 01-1 .14H0z"
      fill="fill"
    />
  </svg>
);

const Svg4 = props => (
  <svg viewBox="0 0 117.38 140" width="1em" height="1em" {...props}>
    <path
      d="M117.38 77L66 76.58c.28 4.76.42 10.08.42 15 0 1.82.14 3.5.28 5.32 0 .7.14 1.68.14 2.66.14 1.82 0 3.36 0 5.18V140H59.7a75.56 75.56 0 00.56-8.68l-.14-8c-.14-4.76-.14-11.2-.14-16 0-5.18-.14-10.64-.28-16-.28-5-.42-9.94-.42-15-9.52 0-19.32.28-28.7.28l-15 .14h-7.4l-3.64-.14H.06c-.14-2.24 0-5 0-7.14V57.12L.34 19.6C.48 13.3.48 6.3.48 0h5.6c.14 1.54.42 2.94.42 3.78s.14 1.12.14 1.54v8.54c0 1.54.14 3.08.14 4.34 0 2.94-.14 5.74-.14 8.68v8.54c0 3.92.14 7.84.28 11.62 0 2 .14 3.92.14 5.88.14 4.9.14 11.34.14 16.38 17.92 0 34.3.14 52.08.14L60.26 0h5.32a45.38 45.38 0 01.28 5.32V14c0 1.54.14 3.08.14 4.34v51.38l51.38.42z"
      fill="fill"
    />
  </svg>
);

const Svg5 = props => (
  <svg viewBox="0 0 62.44 140" width="1em" height="1em" {...props}>
    <path
      d="M7 10.22v1.4c0 1.26.14 2.52.14 3.78V33l.14 26.88a29 29 0 017 .56 5.2 5.2 0 001.26.28c.28 0 .56.14.84.14 2.66.56 5.46 1.12 8.26 1.82a63.33 63.33 0 0116.94 6.86 41.56 41.56 0 017.28 6 40.08 40.08 0 015.14 7.9 39.09 39.09 0 013.08 18.34A34.67 34.67 0 0150.54 119a36.62 36.62 0 01-6.72 6.44c-2.1 1.4-4.76 3.08-7.84 4.9l-1.12.56c-2.66 1.26-5.46 2.8-7.14 3.64a74.9 74.9 0 01-8.82 2.66l-9 2.1c-.14 0-.28.14-.56.14l-.84.28a45.37 45.37 0 01-6.16.28H0v-1.4a1.06 1.06 0 01.14-.6v-1.82c-.14-.14-.14-.56-.14-.7v-1.26l3.22-.7c4.62-.7 9.1-1.26 13.86-2.38l3.92-1.22 4.06-1.54 1.82-.84a47.4 47.4 0 005.32-2.8 40.46 40.46 0 006.86-4.74 31.74 31.74 0 005.6-5.88c.84-1.26 2-2.66 2.38-3.5l1.68-3.78a51.46 51.46 0 00.84-8 26.81 26.81 0 00-.56-8.26 17.36 17.36 0 00-3.36-7.28 39 39 0 00-5.46-6.16 49.51 49.51 0 00-6.72-4.76 33 33 0 00-7.7-2.66A52.21 52.21 0 0017.64 68a78.86 78.86 0 00-8.12-.42c-.56 0-1.12.14-1.68.14H5.18c-1 0-2.8.28-4.76.42L.14 0h62.3v6.58L7.28 6v.42a3.94 3.94 0 00-.14 1.12V9.1c0 .42-.14.84-.14 1.12z"
      fill="fill"
    />
  </svg>
);

const Svg6 = props => (
  <svg viewBox="0 0 67.54 139.86" width="1em" height="1em" {...props}>
    <path
      d="M32.06 139.58a7 7 0 01-2.24-.42 21.54 21.54 0 01-2.66-1.16 1.06 1.06 0 01-.56-.28 3.59 3.59 0 01-.7-.28l-4.06-2.24-1-1.12c-.28 0-.56-.42-.84-.7l-.84-.84A80.54 80.54 0 0113 125a45.7 45.7 0 01-4-9.08c-1-2.8-1.82-6.16-2.66-9.38v.14a75.71 75.71 0 01-2-9.52c-1-6.16-2-13-2.52-19C1.12 71.68.7 65.1.56 58.52c0-6.3-.14-12.74-.28-19.18L0 34.44c0-1.54 0-3.08.14-4.76.14-1 .14-3.78.14-4.76C.14 23.66.14 21 .14 20 0 17.22 0 13.16 0 10.5 0 7.28 0 3.22.14 0H6.3l1.12 49.84C7.7 58 8 66.22 8.54 74.2c.28 4.2.56 8.26 1 12l.7 6.16.7 2.94c.14.7 0 .14.14.84a57 57 0 017.28-13.86 38.05 38.05 0 016.44-6 20 20 0 018-3.78 23.17 23.17 0 014.48-.42h4.34a22.61 22.61 0 014.62.42 11.66 11.66 0 012.1.56l2.1 1A36.27 36.27 0 0158 78.68a22.11 22.11 0 015.32 7 31.17 31.17 0 014.2 17.22A57 57 0 0164 120a32.85 32.85 0 01-4.06 8 57.24 57.24 0 01-5.74 5.88l-2 1.54h.14a8.73 8.73 0 01-2.34 1.5 21.37 21.37 0 01-4.06 1.54l-2.66.84a3.88 3.88 0 00-1.26.14c-.42 0-.84.14-1.26.14a15.43 15.43 0 01-2.52.28H37a26.41 26.41 0 01-4.94-.28zm4.48-5.74a13.79 13.79 0 002.38-.28 27.61 27.61 0 009.1-3.92 34.6 34.6 0 006.58-7 58.73 58.73 0 006.58-18.76 13.79 13.79 0 00.28-2.38 5.65 5.65 0 00-.14-2.1 13.29 13.29 0 00-1.26-4.9 33 33 0 00-5.46-8.12 43.59 43.59 0 00-8-5.88 29.38 29.38 0 00-6.44-2 1.78 1.78 0 00-.84-.14h-.7c-.14 0-.28-.14-.42-.14h-1a16.85 16.85 0 00-8.68 3.5 27 27 0 00-6.16 7.56 67.74 67.74 0 00-6 18.9 12.33 12.33 0 00-.28 2.38 12.81 12.81 0 00.14 2.24 15.79 15.79 0 001.12 4.9l2.1 4.62v-.14a14.05 14.05 0 002.8 3.92l2 2a1.69 1.69 0 00.7.7 11.19 11.19 0 003.78 2.8l1.12.56h-.14a24.87 24.87 0 004.62 1.68 3.09 3.09 0 002.22 0z"
      fill="fill"
    />
  </svg>
);

const Svg7 = props => (
  <svg viewBox="0 0 112.42 140" width="1em" height="1em" {...props}>
    <path
      d="M112.42 0L9.8 140H0L98.84 6.72 1 6.3V0a68.09 68.09 0 007.54 0H35.7c2.38 0 4.76.14 7 .14L56.42 0z"
      fill="fill"
    />
  </svg>
);

const Svg8 = props => (
  <svg viewBox="0 0 59.78 140" width="1em" height="1em" {...props}>
    <path
      d="M3.64 20.16a40.84 40.84 0 015.74-9.8 5.69 5.69 0 012-2.1 28.28 28.28 0 016.3-5.18A22.36 22.36 0 0128.42 0 24.68 24.68 0 0139.2 2.1 23.63 23.63 0 0144 5.32a17.36 17.36 0 013.92 3.92 38.76 38.76 0 015.6 9.66 42.42 42.42 0 012.8 10.64 30.16 30.16 0 01-.84 11.2 59.54 59.54 0 01-3.92 10.5 30.1 30.1 0 01-2.94 4.9l-1.4 1.54a18.26 18.26 0 01-2.1 2.52 25 25 0 01-4.34 3.64 27.16 27.16 0 01-3.36 2.1L41.3 68l2.7 1.58a31.62 31.62 0 002.52 2.1 39.17 39.17 0 014.2 4.48 10.27 10.27 0 012 2.52L54 81.2l2.42 4.8.28 1a25.94 25.94 0 011.54 4.76l.28 1.24a50.71 50.71 0 011.26 12.18 31 31 0 01-.56 6.3 34.05 34.05 0 01-1.68 6 50.24 50.24 0 01-4.9 9.38l-1 1.54a33.52 33.52 0 01-9.24 8.4 23.85 23.85 0 01-12 3.22 22.83 22.83 0 01-11.76-2.8c-3.78-2.24-6.16-4.9-8.82-7.84a39.28 39.28 0 01-5.74-9.8A54.15 54.15 0 011.4 111l-.56-2a42.66 42.66 0 01-.84-5.26v-3.08a29.65 29.65 0 011-6.3c0-.14.28-.56.28-.7a22.21 22.21 0 012.1-4.9c.7-1.4 1.54-3.08 2.38-4.48l.56-.84 3.22-5c1-1.26 2-2.38 3.22-3.78l.84-1 2.1-2.24 2.24-2.1.56-.56a9.14 9.14 0 011.68-1.54l1.68-1.26c-1.26-1.12-1.82-1.26-2.66-2l-2.52-2.24-4.34-3.92-.42-.42c-.42-.28-2.1-1.54-2.1-1.54l-1-1-3.08-3.32-1-1.26a27.28 27.28 0 01-1.4-3.08L1.68 42a19.79 19.79 0 01-1.12-5.46 10.33 10.33 0 010-2.94A9 9 0 011 30.8a40.86 40.86 0 012.64-10.64zm32.48 51.66l-2.8-.82h-.42c-.28 0-.42-.14-.56-.14h-.56l-.42-.14c-.28.14-2.66.42-3.78.56a16.33 16.33 0 00-2.94 1.12 23.76 23.76 0 00-4.06 3.22A55.65 55.65 0 0015.12 82c-.28.56-1.12 1.54-1.4 2.1a30.21 30.21 0 00-2.38 4.34l-1.4 2.38c-.42.56-1.26 2.38-1.26 2.1l-.56 2.28-1 3.08a24.56 24.56 0 00-.42 5.46c-.14 5.88 1.82 11.76 4.9 17.22a2.51 2.51 0 01.84 1.4l.56 1 3.5 3.92c1.4 1 2.66 2.1 4.2 3.08a35.25 35.25 0 009.94 2.24 12.25 12.25 0 004.9-1l.7-.14a11 11 0 004.06-2.1l3.5-3.64a22.31 22.31 0 003.36-4.06 43.83 43.83 0 004.62-9.24 46 46 0 001.26-5.18 21.75 21.75 0 00.14-5.18c0-.56-1.26-5.74-1.68-7.14l-.84-2.66-.7-2c-.28-.84-.84-2.24-.7-2-.84-1.82-1.4-3.22-2.38-5l-1.82-3.08-1.66-1.78a30.5 30.5 0 00-2.94-3.64 14 14 0 00-4.34-2.94zM7.14 35a28.73 28.73 0 003.92 13.44c.14.14.28.7.42.7A29.76 29.76 0 0015 52.36l1.4 1.12a32.57 32.57 0 005.6 3.78 36.42 36.42 0 004 2.38 8.67 8.67 0 004.2 1.26 13.63 13.63 0 004.48-1 11 11 0 003.64-2.38 42.11 42.11 0 006.3-7.28A28.64 28.64 0 0048.86 42 17.16 17.16 0 0050 37.38a26 26 0 00.56-4.62 27.88 27.88 0 00-1.82-9.38 35.83 35.83 0 00-4.48-8.12A17.17 17.17 0 0037.1 9.8 33.5 33.5 0 0028 8.26a10.46 10.46 0 00-2.8.42 1.68 1.68 0 00-1.12.32 28.91 28.91 0 00-4.76 2.1 4.44 4.44 0 00-.84.7 24.8 24.8 0 00-5.74 5.74A27.27 27.27 0 007.14 35z"
      fill="fill"
    />
  </svg>
);

const Svg9 = props => (
  <svg viewBox="0 0 53.62 140" width="1em" height="1em" {...props}>
    <path
      d="M53.62 140h-7l-.28-84.42a18.53 18.53 0 01-4.62 4.06 36.35 36.35 0 01-7.84 3.78 36.84 36.84 0 01-8.4 2.38 20.8 20.8 0 01-8.82-.56 20.54 20.54 0 01-7.84-4.34 32 32 0 01-5.46-7 25.15 25.15 0 01-2.94-8.4A26.18 26.18 0 010 40.74a19.4 19.4 0 01.42-4.2 52.61 52.61 0 012.52-8.26 54.7 54.7 0 014.34-7.84 65.68 65.68 0 0111.9-12.88A60.26 60.26 0 0127 3.08 37.64 37.64 0 0135.28.84 60.73 60.73 0 0144.1 0h9.38zM41.86 6.58a40 40 0 00-14.7 4.48 45.59 45.59 0 00-12.32 9.38A31.84 31.84 0 007.56 34a22.84 22.84 0 00-.84 7.56A23.23 23.23 0 007 44.94a15.11 15.11 0 001.4 3.78 27.29 27.29 0 004.34 6.44 22.49 22.49 0 006.58 3.36 22 22 0 007.42 0 23.84 23.84 0 007.14-2.38 26.57 26.57 0 006-4.62c1.12-2 2.66-4.9 3.5-6.72a40.8 40.8 0 001.56-7.8 65.91 65.91 0 00.7-7.56v-.7l.14-1v-5.2l.42-16z"
      fill="fill"
    />
  </svg>
);

const Svg10 = props => (
  <svg viewBox="0 0 147.84 140.32" width="1em" height="1em" {...props}>
    <path
      d="M.28 140.29s-.14-6.58-.14-9.24l-.14-9 .42-51.62c.14-23.1.42-47 .7-70.14h6.72l-.14 140zM147.84 69.87v3.5c0 .56-.14 1.26-.14 1.68v1.26l-.14 1c0 .56-.14 2-.14 2.8v.42A78.9 78.9 0 01143.64 97a76.79 76.79 0 01-12 22.68c-5.18 6-12.32 12.18-19.74 15.68a55.33 55.33 0 01-25.06 4.9 52.81 52.81 0 01-24.5-7.14c-6.86-4.06-13.3-11.06-18.06-17.78-5.18-6.72-8.82-14.84-11.34-22.82a64.65 64.65 0 01-3.22-12.18 50.43 50.43 0 01-.84-13.16 97.59 97.59 0 015-24.64A71.79 71.79 0 0146.06 20c5.18-6.44 12-12.32 20-15.68S82.6-.13 91 0c8.82.42 17.22 2.24 24.78 6.16a52.87 52.87 0 0118.9 17.08 76.17 76.17 0 0110.08 23.52 99.94 99.94 0 012.94 20.58c0 .85.14 1.55.14 2.53zm-68.32 62.58l2.24.42a1.41 1.41 0 00.42.14 17.15 17.15 0 002.66.28 5.74 5.74 0 001.54.14h3.78l2-.14c.14 0 .42-.14.56-.14a7.22 7.22 0 001.54-.28 1.78 1.78 0 00.84-.14 11 11 0 002-.28c.14 0 .28-.14.42-.14l2.24-.42a46.42 46.42 0 009.66-3.92 53.2 53.2 0 0016.94-14.7A57 57 0 00137 93.11 70.12 70.12 0 00140.28 71a81.63 81.63 0 00-2.94-22.82 59.84 59.84 0 00-9.24-20.58 94 94 0 00-6.58-7.7l-2.1-1.68a99.36 99.36 0 00-8-6 53.21 53.21 0 00-21.7-5.74A43.93 43.93 0 0068 11.63a72.22 72.22 0 00-16.9 15.12 80.8 80.8 0 00-11.2 19.74 81.59 81.59 0 00-4.34 22 61.23 61.23 0 003.64 22.66A67.61 67.61 0 0050.26 111a69.06 69.06 0 0016.24 15.71 35.82 35.82 0 0012.74 5.6z"
      fill="fill"
    />
  </svg>
);

const Svg11 = props => (
  <svg viewBox="0 0 64.26 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM56.7 140s-.14-6.58-.14-9.24l-.14-9 .42-51.66c.14-23.1.42-47 .7-70.14h6.72l-.14 140z"
      fill="fill"
    />
  </svg>
);

const Svg12 = props => (
  <svg viewBox="0 0 119.42 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM48.3 140v-7.42A209.12 209.12 0 0067.76 120c6.3-4.62 12.74-9.38 17.64-14.14a86.55 86.55 0 007.42-8.68 70.35 70.35 0 006-9.38c3.22-6.58 5.6-14.28 5.46-21.56v-5.9c-.14-1.82-.28-3.5-.56-5.46a42.58 42.58 0 00-3.2-10.88 56 56 0 00-5.32-10 82.56 82.56 0 00-5.46-6.86l-2.38-2.8a12.69 12.69 0 00-3.08-3.08l-2.66-2.36-1.54-1.54c-3.08-2.24-6-4.62-9.38-5.88A58.93 58.93 0 0060.2 7.7 37.4 37.4 0 0048.3 7V0h2.38A49.68 49.68 0 0160.9 1.12a17.36 17.36 0 013.1.56l1.26.42 1.54.42L71 3.78c.42 0 .56.7 1.26.7l3.5 1.68c2.1 1.12 5.18 2.66 7.14 3.92a43 43 0 014.9 3.36 35.31 35.31 0 014.6 4.06 65 65 0 017.42 9.24A86.1 86.1 0 01106 37a54.14 54.14 0 013.92 11.62 86.15 86.15 0 011.4 11.9c.14 1.82.28 4.2.28 6a43.34 43.34 0 01-.28 6 52.21 52.21 0 01-2.8 11.62 90.56 90.56 0 01-4.62 11.2l-.9 1.54a25.82 25.82 0 00-2.38 3.92l-3.78 4.34a147.92 147.92 0 01-17.64 15.68L69.72 128 62 133.42h57.4V140z"
      fill="fill"
    />
  </svg>
);

const Svg13 = props => (
  <svg viewBox="0 0 100.8 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM49.7 132.72c.56 0 2 .14 2.52.14h1.68a36.72 36.72 0 013.78.14c1.26 0 3.36-.14 4.62-.28.84 0 1.54-.14 2.38-.14l3.36-.14L72 132a18.25 18.25 0 002.94-.56 14.28 14.28 0 003.92-1.26 22.68 22.68 0 004.76-3.5l.28-.28a27.74 27.74 0 004.9-5.46 34.16 34.16 0 005.46-12.6 27.81 27.81 0 00.7-5.6 24.45 24.45 0 00-1.26-8 10.16 10.16 0 00-1.4-3.5 17.91 17.91 0 01-1.54-3.22 22.52 22.52 0 00-4.48-5.18 27.77 27.77 0 00-5.6-4.2 30.64 30.64 0 00-6.44-2.94c-4.48-1.54-9.1-3.08-13.44-2.66l-5.18.28v-7.24a37.13 37.13 0 0014.56-2 45.06 45.06 0 0011.48-6.58 23.37 23.37 0 004.2-4.06l1.54-1.68 1.54-2.24.56-1 1-2c.14-.42.42-.7.56-1.12a23.89 23.89 0 001.82-5.32 24.83 24.83 0 001-7 26.73 26.73 0 00-.28-2.8 9.14 9.14 0 00-.28-1.54 20.1 20.1 0 00-1-2.24 23.53 23.53 0 00-3.98-5.5c-3.08-3.5-7.14-6-11.34-8.26A67.2 67.2 0 0064.54 8a43.27 43.27 0 00-9.24-1 53.68 53.68 0 00-5.6.28V0c2.24 0 5.46 0 7.7.14s4.2.28 6.3.56c.28 0 .42.14.7.14a32.8 32.8 0 016.86 1.68A25.72 25.72 0 0178 5.18a48.76 48.76 0 0111.6 7.56A34.68 34.68 0 0198 24.22a18 18 0 011.82 7.14 25.42 25.42 0 01-.28 7.28 35.12 35.12 0 01-1.68 6.86 49.86 49.86 0 01-2.1 6.44 28.18 28.18 0 01-2 3.5l-2.1 2.94a28.61 28.61 0 01-5 5 40.46 40.46 0 01-6 3.78l-6.3 2.38s9.38 1.26 14.84 5c3.78 3.08 5.74 6.72 7.7 10.64l.42.84a32.84 32.84 0 012.38 7.14 16.43 16.43 0 01.7 3.78l.28 3.64a34.12 34.12 0 01.14 3.78 37 37 0 01-.28 3.78 46.63 46.63 0 01-1.68 7.28c-1.4 4.48-3.22 9.66-6.58 13.44s-8.12 6.44-12.74 8.12a48.26 48.26 0 01-7.14 1.82 66.47 66.47 0 01-7.42.7l-7.28.28a7.89 7.89 0 01-1 .14h-7z"
      fill="fill"
    />
  </svg>
);

const Svg14 = props => (
  <svg viewBox="0 0 161.98 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM162 77l-51.38-.42c.28 4.76.42 10.08.42 15 0 1.82.14 3.5.28 5.32 0 .7.14 1.68.14 2.66.14 1.82 0 3.36 0 5.18V140h-7.16a75.56 75.56 0 00.56-8.68l-.14-8c-.14-4.76-.14-11.2-.14-16 0-5.18-.14-10.64-.28-16-.28-5-.42-9.94-.42-15-9.52 0-19.32.28-28.7.28l-15 .14h-7.4l-3.64-.14h-4.48c-.14-2.24 0-5 0-7.14V57.12l.28-37.52c.14-6.3.14-13.3.14-19.6h5.6c.14 1.54.42 2.94.42 3.78s.14 1.12.14 1.54v8.54c0 1.54.14 3.08.14 4.34 0 2.94-.14 5.74-.14 8.68v8.54c0 3.92.14 7.84.28 11.62 0 2 .14 3.92.14 5.88.14 4.9.14 11.34.14 16.38 17.92 0 34.3.14 52.08.14l1-69.44h5.32a45.38 45.38 0 01.28 5.32V14c0 1.54.14 3.08.14 4.34v51.38l51.38.42z"
      fill="fill"
    />
  </svg>
);

const Svg15 = props => (
  <svg viewBox="0 0 112.98 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM57.54 10.22v1.4c0 1.26.14 2.52.14 3.78V33l.14 26.88a29 29 0 017 .56 5.2 5.2 0 001.26.28c.28 0 .56.14.84.14 2.66.56 5.46 1.12 8.26 1.82a63.33 63.33 0 0116.94 6.86 41.56 41.56 0 017.28 6 40.08 40.08 0 015.18 7.84 39.09 39.09 0 013.08 18.34 34.67 34.67 0 01-6.58 17.28 36.62 36.62 0 01-6.72 6.44c-2.1 1.4-4.76 3.08-7.84 4.9l-1.12.56c-2.66 1.26-5.46 2.8-7.14 3.64a74.9 74.9 0 01-8.82 2.66l-9 2.1c-.14 0-.28.14-.56.14l-.84.28a45.37 45.37 0 01-6.16.28h-2.34v-1.4a1.06 1.06 0 01.14-.56v-1.82c-.14-.14-.14-.56-.14-.7v-1.26l3.22-.7c4.62-.7 9.1-1.26 13.86-2.38l3.92-1.26 4.06-1.54 1.82-.84a47.4 47.4 0 005.32-2.8A40.46 40.46 0 0089.6 120a31.74 31.74 0 005.6-5.88c.84-1.26 2-2.66 2.38-3.5l1.68-3.78a51.46 51.46 0 00.84-8 26.81 26.81 0 00-.56-8.26 17.36 17.36 0 00-3.36-7.28 39 39 0 00-5.46-6.16A49.51 49.51 0 0084 72.38a33 33 0 00-7.7-2.66A52.21 52.21 0 0068.18 68a78.86 78.86 0 00-8.12-.42c-.56 0-1.12.14-1.68.14h-2.66c-1 0-2.8.28-4.76.42L50.68 0H113v6.58L57.82 6v.42a3.94 3.94 0 00-.14 1.12V9.1c0 .42-.14.84-.14 1.12z"
      fill="fill"
    />
  </svg>
);

const Svg16 = props => (
  <svg viewBox="0 0 119.9 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM84.42 139.58a7 7 0 01-2.24-.42 21.54 21.54 0 01-2.66-1.16 1.06 1.06 0 01-.56-.28 3.59 3.59 0 01-.7-.28l-4.06-2.24-1-1.12c-.28 0-.56-.42-.84-.7l-.84-.84a80.54 80.54 0 01-6.14-7.54 45.7 45.7 0 01-4.06-9.1c-1-2.8-1.82-6.16-2.66-9.38v.14a75.71 75.71 0 01-2-9.52c-1-6.16-2-13-2.52-19-.7-6.44-1.12-13-1.26-19.6 0-6.3-.14-12.74-.28-19.18l-.28-4.9c0-1.54 0-3.08.14-4.76.14-1 .14-3.78.14-4.76-.1-1.28-.1-3.94-.1-4.94-.14-2.8-.14-6.86-.14-9.52 0-3.22 0-7.28.14-10.5h6.16l1.12 49.84c.28 8.12.56 16.38 1.12 24.36.28 4.2.56 8.26 1 12l.7 6.16.7 2.94c.14.7 0 .14.14.84a57 57 0 017.26-13.8 38.05 38.05 0 016.44-6 20 20 0 018-3.78 23.17 23.17 0 014.48-.42h4.34a22.61 22.61 0 014.62.42 11.66 11.66 0 012.1.56l2.1 1a36.27 36.27 0 017.56 4.62 22.11 22.11 0 015.32 7 31.17 31.17 0 014.2 17.22 57 57 0 01-3.5 17.08 32.85 32.85 0 01-4.06 8 57.24 57.24 0 01-5.74 5.88l-2 1.54h.14a8.73 8.73 0 01-2.38 1.54 21.37 21.37 0 01-4.06 1.54l-2.66.84a3.88 3.88 0 00-1.26.14c-.42 0-.84.14-1.26.14a15.43 15.43 0 01-2.52.28h-1.24a26.41 26.41 0 01-4.9-.34zm4.48-5.74a13.79 13.79 0 002.38-.28 27.61 27.61 0 009.1-3.92 34.6 34.6 0 006.58-7 58.73 58.73 0 006.58-18.76 13.79 13.79 0 00.28-2.38 5.65 5.65 0 00-.14-2.1 13.29 13.29 0 00-1.26-4.9 33 33 0 00-5.42-8.12 43.59 43.59 0 00-8-5.88 29.38 29.38 0 00-6.44-2 1.78 1.78 0 00-.84-.14H91c-.14 0-.28-.14-.42-.14h-1a16.85 16.85 0 00-8.68 3.5 27 27 0 00-6.16 7.56 67.74 67.74 0 00-6 18.9 12.33 12.33 0 00-.28 2.38 12.81 12.81 0 00.14 2.24 15.79 15.79 0 001.12 4.9l2.1 4.62v-.14a14.05 14.05 0 002.8 3.92l2 2a1.69 1.69 0 00.7.7 11.19 11.19 0 003.78 2.8l1.12.56H82a24.87 24.87 0 004.62 1.68 3.09 3.09 0 002.28 0z"
      fill="fill"
    />
  </svg>
);

const Svg17 = props => (
  <svg viewBox="0 0 158.76 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM158.76 0L56.14 140h-9.8L145.18 6.72 47.32 6.3V0a68.09 68.09 0 007.56 0H82c2.38 0 4.76.14 7 .14L102.76 0z"
      fill="fill"
    />
  </svg>
);

const Svg18 = props => (
  <svg viewBox="0 0 113.54 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM57.4 20.16a40.84 40.84 0 015.74-9.8 5.69 5.69 0 012-2.1 28.28 28.28 0 016.3-5.18A22.36 22.36 0 0182.18 0 24.68 24.68 0 0193 2.1a23.63 23.63 0 014.76 3.22 17.36 17.36 0 013.92 3.92 38.76 38.76 0 015.6 9.66A42.42 42.42 0 01110 29.54a30.16 30.16 0 01-.84 11.2 59.54 59.54 0 01-3.92 10.5 30.1 30.1 0 01-2.94 4.9l-1.4 1.54a18.26 18.26 0 01-2.1 2.52 25 25 0 01-4.34 3.64 27.16 27.16 0 01-3.36 2.1L95.06 68l2.66 1.54a31.62 31.62 0 002.52 2.1 39.17 39.17 0 014.2 4.48 10.27 10.27 0 012 2.52l1.4 2.52 2.34 4.84.28 1a25.94 25.94 0 011.54 4.7l.28 1.26a50.71 50.71 0 011.26 12.18 31 31 0 01-.56 6.3 34.05 34.05 0 01-1.68 6 50.24 50.24 0 01-4.9 9.38l-1 1.54a33.52 33.52 0 01-9.24 8.4 23.85 23.85 0 01-12 3.22 22.83 22.83 0 01-11.76-2.8c-3.78-2.24-6.16-4.9-8.82-7.84a39.28 39.28 0 01-5.74-9.8 54.15 54.15 0 01-2.68-8.54l-.56-2a42.66 42.66 0 01-.84-5.32v-3.08a29.65 29.65 0 011-6.3c0-.14.28-.56.28-.7a22.21 22.21 0 012.1-4.9c.7-1.4 1.54-3.08 2.38-4.48l.56-.84 3.22-5c1-1.26 2-2.38 3.22-3.78l.84-1 2.1-2.24 2.24-2.1.56-.56a9.14 9.14 0 011.68-1.54l1.68-1.26c-1.26-1.12-1.82-1.26-2.66-2l-2.52-2.24-4.34-3.92-.42-.42c-.42-.28-2.1-1.54-2.1-1.54l-1-1-3.08-3.26-1-1.26a27.28 27.28 0 01-1.4-3.08L55.44 42a19.79 19.79 0 01-1.12-5.46 10.33 10.33 0 010-2.94 9 9 0 01.42-2.8 40.86 40.86 0 012.66-10.64zm32.48 51.66l-2.8-.82h-.42c-.28 0-.42-.14-.56-.14h-.56l-.42-.14c-.28.14-2.66.42-3.78.56a16.33 16.33 0 00-2.94 1.12 23.76 23.76 0 00-4.06 3.22A55.65 55.65 0 0068.88 82c-.28.56-1.12 1.54-1.4 2.1a30.21 30.21 0 00-2.38 4.34l-1.4 2.38c-.42.56-1.26 2.38-1.26 2.1l-.56 2.24-1 3.08a24.56 24.56 0 00-.42 5.46c-.14 5.88 1.82 11.76 4.9 17.22a2.51 2.51 0 01.84 1.4l.56 1 3.5 3.92c1.4 1 2.66 2.1 4.2 3.08a35.25 35.25 0 009.94 2.24 12.25 12.25 0 004.9-1l.7-.14a11 11 0 004.06-2.1l3.5-3.64a22.31 22.31 0 003.36-4.06 43.83 43.83 0 004.62-9.24 46 46 0 001.26-5.18 21.75 21.75 0 00.14-5.18c0-.56-1.26-5.74-1.68-7.14l-.84-2.66-.7-2c-.28-.84-.84-2.24-.7-2-.84-1.82-1.4-3.22-2.38-5l-1.82-3.08-1.66-1.74a30.5 30.5 0 00-2.94-3.64 14 14 0 00-4.34-2.94zM60.9 35a28.73 28.73 0 003.92 13.44c.14.14.28.7.42.7a29.76 29.76 0 003.5 3.22l1.4 1.12a32.57 32.57 0 005.6 3.78 36.42 36.42 0 004.06 2.38A8.67 8.67 0 0084 60.9a13.63 13.63 0 004.48-1 11 11 0 003.64-2.38 42.11 42.11 0 006.3-7.28 28.64 28.64 0 004.2-8.26 17.16 17.16 0 001.12-4.62 26 26 0 00.56-4.62 27.88 27.88 0 00-1.82-9.38 35.83 35.83 0 00-4.48-8.1 17.17 17.17 0 00-7.14-5.46 33.5 33.5 0 00-9.1-1.54 10.46 10.46 0 00-2.8.42 1.68 1.68 0 00-1.12.32 28.91 28.91 0 00-4.76 2.1 4.44 4.44 0 00-.84.7 24.8 24.8 0 00-5.74 5.7A27.27 27.27 0 0060.9 35z"
      fill="fill"
    />
  </svg>
);

const Svg19 = props => (
  <svg viewBox="0 0 91.42 140" width="1em" height="1em" {...props}>
    <path
      d="M.28 140s-.14-6.58-.14-9.24l-.14-9 .42-51.62C.56 47 .84 23.1 1.12 0h6.72L7.7 140zM91.42 140h-7l-.28-84.42a18.53 18.53 0 01-4.62 4.06 36.35 36.35 0 01-7.84 3.78 36.84 36.84 0 01-8.4 2.38 20.8 20.8 0 01-8.82-.56 20.54 20.54 0 01-7.84-4.34 32 32 0 01-5.46-7 25.15 25.15 0 01-2.94-8.4 26.18 26.18 0 01-.42-4.76 19.4 19.4 0 01.42-4.2 52.61 52.61 0 012.52-8.26 54.7 54.7 0 014.34-7.84A65.68 65.68 0 0157 7.56a60.26 60.26 0 017.84-4.48A37.64 37.64 0 0173.08.84 60.73 60.73 0 0181.9 0h9.38zM79.66 6.58A40 40 0 0065 11.06a45.59 45.59 0 00-12.32 9.38A31.84 31.84 0 0045.36 34a22.84 22.84 0 00-.84 7.56 23.23 23.23 0 00.28 3.36 15.11 15.11 0 001.4 3.78 27.29 27.29 0 004.34 6.44 22.49 22.49 0 006.58 3.36 22 22 0 007.42 0 23.84 23.84 0 007.14-2.38 26.57 26.57 0 006-4.62c1.12-2 2.66-4.9 3.5-6.72A40.8 40.8 0 0082.74 37a65.91 65.91 0 00.7-7.56v-.7l.14-1v-5.2l.42-16z"
      fill="fill"
    />
  </svg>
);

const Svg20 = props => (
  <svg viewBox="0 0 215.18 140.32" width="1em" height="1em" {...props}>
    <path
      d="M0 140.29v-7.42a209.12 209.12 0 0019.46-12.6c6.3-4.62 12.74-9.38 17.64-14.14a86.55 86.55 0 007.42-8.68 70.35 70.35 0 006-9.38c3.22-6.58 5.6-14.28 5.46-21.56v-5.88c-.14-1.82-.28-3.5-.56-5.46a42.58 42.58 0 00-3.22-10.92 56 56 0 00-5.32-9.94 82.56 82.56 0 00-5.46-6.86l-2.38-2.8A12.69 12.69 0 0036 21.57l-2.66-2.38-1.54-1.54c-3.08-2.24-6-4.62-9.38-5.88A58.93 58.93 0 0011.9 8 37.4 37.4 0 000 7.29v-7h2.38A49.68 49.68 0 0112.6 1.41a17.36 17.36 0 013.08.59l1.26.42 1.54.42 4.2 1.26c.42 0 .56.7 1.26.7l3.5 1.68c2.1 1.12 5.18 2.66 7.14 3.92a43 43 0 014.9 3.36 35.31 35.31 0 014.62 4.06A65 65 0 0151.52 27a86.1 86.1 0 016.16 10.22 54.14 54.14 0 013.92 11.65 86.15 86.15 0 011.4 11.9c.14 1.82.28 4.2.28 6a43.34 43.34 0 01-.28 6 52.21 52.21 0 01-2.8 11.62 90.56 90.56 0 01-4.62 11.2l-.84 1.54a25.82 25.82 0 00-2.38 3.92l-3.78 4.34a147.92 147.92 0 01-17.64 15.68l-9.52 7.14-7.7 5.46h57.4v6.58zM215.18 69.87v3.5c0 .56-.14 1.26-.14 1.68v1.26l-.14 1c0 .56-.14 2-.14 2.8v.42A78.9 78.9 0 01211 97a76.79 76.79 0 01-12 22.68c-5.18 6-12.32 12.18-19.74 15.68a55.33 55.33 0 01-25.06 4.9 52.81 52.81 0 01-24.5-7.14c-6.86-4.06-13.3-11.06-18.06-17.78-5.18-6.72-8.82-14.84-11.34-22.82A64.65 64.65 0 0197 80.37a50.43 50.43 0 01-.84-13.16 97.59 97.59 0 015-24.64A71.79 71.79 0 01113.4 20c5.18-6.44 12-12.32 20-15.68S149.94-.13 158.34 0c8.82.42 17.22 2.24 24.78 6.16A52.87 52.87 0 01202 23.25a76.17 76.17 0 0110.1 23.52 99.94 99.94 0 012.9 20.58c0 .84.18 1.54.18 2.52zm-68.32 62.58l2.24.42a1.41 1.41 0 00.42.14 17.15 17.15 0 002.66.28 5.74 5.74 0 001.54.14h3.78l2-.14c.14 0 .42-.14.56-.14a7.22 7.22 0 001.54-.28 1.78 1.78 0 00.84-.14 11 11 0 002-.28c.14 0 .28-.14.42-.14l2.24-.42a46.42 46.42 0 009.66-3.92 53.2 53.2 0 0016.94-14.7 57 57 0 0010.64-20.16A70.12 70.12 0 00207.62 71a81.63 81.63 0 00-2.94-22.82 59.84 59.84 0 00-9.24-20.58 94 94 0 00-6.58-7.7l-2.1-1.68a99.36 99.36 0 00-8-6 53.21 53.21 0 00-21.7-5.74 43.93 43.93 0 00-21.7 5.18 72.22 72.22 0 00-16.94 15.12 80.8 80.8 0 00-11.2 19.74 81.59 81.59 0 00-4.34 22 61.23 61.23 0 003.64 22.68A67.61 67.61 0 00117.6 111a69.06 69.06 0 0016.24 15.68 35.82 35.82 0 0012.74 5.6z"
      fill="fill"
    />
  </svg>
);

// Letters

const SvgA = props => (
  <svg viewBox="0 0 113.96 140" {...props}>
    <path
      d="M107.52 140c-4.62-12.6-12.32-30.1-19.46-46.48-3.22-6.86-5.74-13.44-8.54-20.16h-48C23.38 95.62 15.12 117.74 7.14 140H0c5.74-14.56 11.62-29.26 16.52-42.28C19.6 90 22.4 82.46 25.2 75.32 37.24 44.24 51.52 6.86 52.78 0h4.34c3.22 8.68 21.56 56.28 27 69.3 4.48 9.66 12 27.58 17.92 42.14L114 140zM55.16 12.74c-6.86 17.78-13.86 35.56-21 53.48h43.4c-7.56-18.48-14.84-35-22.4-53.48z"
      fill="fill"
    />
  </svg>
);

const SvgB = props => (
  <svg viewBox="0 0 45.93 140.57" {...props}>
    <path
      d="M23.1 72.52c14.56 9 21 22.4 21 34 0 5-1.12 12.74-5.6 18.2-4.62 5.74-8.12 7.7-12.88 10.22A55.66 55.66 0 010 140.56v-14.14c0-8 .14-18.9.14-31.36.14-15.68.14-33.18.14-50S.28 12 0 .7A46.82 46.82 0 018.26 0c4.62 0 10.08 1.26 15 2.8A29.12 29.12 0 0142 20.16c2.1 4.9 4.06 12.6 3.92 15.68v1.4c0 13.16-6.86 29.96-22.82 35.28zm-.28-63.14A72.09 72.09 0 006.16 6.3c0 16.52 0 45.64.14 61.46 1.82.14 5.32.14 6.44.14 11.48 0 26-9.8 26.74-31.08 0-8.68-5.6-23.38-16.66-27.44zM28 84.14c-2.8-3.22-10.36-7.84-16.38-7.84L6.3 76c-.14 6-.14 14.56-.14 23 0 14.42.14 28.84.28 35.28 5.46-.7 11.06-2.8 15.82-4.76 8-3.36 15.68-10.22 15.68-22.26 0-7.02-3.78-15.56-9.94-23.12z"
      fill="fill"
    />
  </svg>
);

const SvgC = props => (
  <svg viewBox="0 0 68.04 140.07" {...props}>
    <path
      d="M58.1 140.07l-4.2-.42c-15.4-1.4-30.8-4.48-44-27.72C5 102.55 0 84.07 0 67.41c0-10.92 2.94-26.18 4.34-30.66C15.12 4.55 38.5.07 55.72.07h1.82a47.35 47.35 0 018.68.28v6.72C64 6.93 61 6.79 58.94 6.79c-44.38 0-49.56 37-51.38 55.86-.14 1.4-.28 3.36-.28 5 0 16.38 6.16 45.64 22.82 57.68a39.61 39.61 0 0015.4 6.16c5.32 1 15.82 1.26 22.54 1.26l-.14 7.28z"
      fill="fill"
    />
  </svg>
);

const SvgD = props => (
  <svg viewBox="0 0 67.64 140.02" {...props}>
    <path
      d="M21.84 137.26c-.14 0-.56.14-1.12.28A60.92 60.92 0 010 139.92V.06h3.92a34 34 0 013.78 0c47 6.58 60.48 53.62 59.92 69 0 21.3-10.08 58.68-45.78 68.2zm20.3-113C28.56 9.3 14.42 7.62 5.74 7.34v125c.56 0 .84.14 1.4.14C37.66 131.1 61 102 61 68.66c.32-10.08-5.28-29.66-18.86-44.38z"
      fill="fill"
    />
  </svg>
);

const SvgE = props => (
  <svg viewBox="0 0 61.6 140" {...props}>
    <path
      d="M6.58 72.8v60.9c18.06 0 37.1.28 55 .28l-.14 6L0 139.86.14 0h61.32l.14 6.16-55.44.28v60.2h55.3v6.16z"
      fill="fill"
    />
  </svg>
);

const SvgF = props => (
  <svg viewBox="0 0 61.6 140.14" {...props}>
    <path
      d="M61.46 66.64v6.16H6.58V140h-2a13.11 13.11 0 01-4.58-.14L.14 0h61.32l.14 6.16-55.44.28v60.2z"
      fill="fill"
    />
  </svg>
);

const SvgG = props => (
  <svg viewBox="0 0 95.48 140" {...props}>
    <path
      d="M78.68 73.08c.56 3.22.56 13.86.56 22.68 0 33.88-9.94 44.24-26.88 44.24A75.26 75.26 0 0135 137.48C31.64 136.64.14 123.06 0 72.8 1.26 31.5 31.64 2.24 56.42.28h-.14S58.94 0 62.44 0a46.52 46.52 0 019.38.84S71.68 6.3 71.68 7a67.32 67.32 0 00-8.12-.56C21 6.44 5.74 54.18 6.16 72.94c.84 47.6 26 57.4 36.68 59.78a37.82 37.82 0 008.4 1 25.5 25.5 0 009.8-1.82c5.6-2.24 11.62-9.66 11.62-36.12 0-9.52-.14-20.3-.14-20.3v-2.4H53.9v-6.44h41.58v6.44z"
      fill="fill"
    />
  </svg>
);

const SvgH = props => (
  <svg viewBox="0 0 73.92 140" {...props}>
    <path
      d="M73.78 140h-7V73.36H7.14c0 22.12-.28 44.52-.28 66.64H0v-1.26L.28.14 6.58 0c0 8.68 0 18.06.14 27.44.14 11.34.28 23.24.28 38.78h59.64V0h7.28z"
      fill="fill"
    />
  </svg>
);

const SvgI = props => (
  <svg viewBox="0 0 39.48 140" {...props}>
    <path
      d="M39.48 134v6H0v-6h15.68L16.1 6.18H0V0h39.48v6.16H23.24c0 21.42 0 40.18-.14 57.68s-.1 48.3-.28 57.16v13z"
      fill="fill"
    />
  </svg>
);

const SvgJ = props => (
  <svg viewBox="0 0 93.1 140" {...props}>
    <path
      d="M93.1 6.16H61.18c0 6-.14 105-.14 105C61 123.62 52.92 140 30.52 140c-7 0-14.14-2.38-18.76-7.14A41.11 41.11 0 010 104.58h7c0 10.5 8.12 28.84 23.52 28.84 16.24 0 23.66-12.18 23.1-24.92L53.48 6.16h-32.2V0H93.1z"
      fill="fill"
    />
  </svg>
);

const SvgK = props => (
  <svg viewBox="0 0 69.02 140" {...props}>
    <path
      d="M7 73.36l-.56.28V140H0V0h6.86l-.14 64c17.5-21.42 35-42.28 52.5-63.7l8.12-.3-56.7 68.88C29.82 92.4 49.84 116.62 69 140h-7.7z"
      fill="fill"
    />
  </svg>
);

const SvgL = props => (
  <svg viewBox="0 0 61.6 140" {...props}>
    <path d="M61.6 134v6L0 139.86.14 0H6.3l.28 134z" fill="fill" />
  </svg>
);

const SvgM = props => (
  <svg viewBox="0 0 109.9 140" {...props}>
    <path
      d="M103.6 16C88.06 57.12 72.24 98.84 56.7 140h-3.22L5.74 16.24c0 40.46.14 83.44.14 123.76H.14L0 0l7.56.14S51.8 120.26 54.74 125.86C70.56 83.86 86.66 42 102.48 0h7.14l.28 140h-6.3z"
      fill="fill"
    />
  </svg>
);

const SvgN = props => (
  <svg viewBox="0 0 91.56 140" {...props}>
    <path
      d="M0 0h7.56L84.7 125 84.28 0h7.28v140h-6L6.72 12.18C6.58 54.74 6.44 97.72 6.3 140H0z"
      fill="fill"
    />
  </svg>
);

const SvgO = props => (
  <svg viewBox="0 0 110.04 140" {...props}>
    <path
      d="M0 72.94C0 44.38 20.44 0 55 0s55 45.92 55 72.94S97 140 55 140 0 101.5 0 72.94zM54.88 6C22 6 6.3 51.52 6.3 72.94s10.5 61 48.44 61S104 96.6 104 72.94C104 54.18 87.78 6 54.88 6z"
      fill="fill"
    />
  </svg>
);

const SvgP = props => (
  <svg viewBox="0 0 57.54 140" {...props}>
    <path
      d="M7.14 76v64H0V1.4C3.08.14 9.1 0 10.78 0c20.58-.28 46.48 15.4 46.76 40.32C57.82 71.54 26.46 76 16.1 76zM11.2 6.16a19.82 19.82 0 00-4.06.28c.14 21.42.28 42.14.42 63.7 1.26.14 2.8 0 4.34 0 14 0 39.48-4.2 39.62-29.82.14-20.16-22.96-34.16-40.32-34.16z"
      fill="fill"
    />
  </svg>
);

const SvgQ = props => (
  <svg viewBox="0 0 110.04 140.56" {...props}>
    <path
      d="M91.84 125c3.64 3.36 7.7 7.56 11.34 10.92l-4.34 4.62-11.48-11.32C79.24 135.94 68.74 140 55 140c-42 0-55-38.5-55-67.06S20.44 0 55 0s55 45.92 55 72.94c0 16.66-4.86 37.94-18.16 52.06zm-9-.28L72.1 114.66l4.34-4.34 10.92 10.22c12-13 16.66-32.9 16.66-47.6C104 54.18 87.78 6 54.88 6S6.3 51.52 6.3 72.94s10.5 61 48.44 61c11.9.06 21.14-3.6 28.14-9.2z"
      fill="fill"
    />
  </svg>
);

const SvgR = props => (
  <svg viewBox="0 0 56.98 140.1" {...props}>
    <path
      d="M6.58 80.46v59.64H0V.1C0 0 6.44 0 10.08.1c15-.28 28 10.5 34.3 20.72a38.79 38.79 0 014.9 17.64c0 12-5.88 25.06-19.46 32.9-2.66 1.4-13 5-18.62 5.18 15 20.86 30.94 42.7 45.78 63.56h-7.14zm4.48-73.78H6.44v63.7h6.16c5.18 0 30.8-5.18 30.8-31.92 0-15.68-15.96-31.78-32.34-31.78z"
      fill="fill"
    />
  </svg>
);

const SvgS = props => (
  <svg viewBox="0 0 69.16 140" {...props}>
    <path
      d="M47.46 0v6.72h-1.82c-19 0-27 6.72-31.36 10.36a20.68 20.68 0 00-5 6.58 23.47 23.47 0 00-2.56 10.22 32.43 32.43 0 002.8 13.72 26.82 26.82 0 007.56 9 38.19 38.19 0 009.8 6.3l11.48 4.76 5.18 2.1 4.06 1.54A45.74 45.74 0 0159.5 79c6.58 5.74 9.66 14.7 9.66 20.44a43.93 43.93 0 01-2.8 14.7 53.25 53.25 0 01-8 13 43.38 43.38 0 01-11.62 9.38A29 29 0 0132.62 140h-.14a41.81 41.81 0 01-21.14-5.74l-.7-.56 3.78-6.16.84.28c0 .14 9.52 4.76 15.26 4.9a26.46 26.46 0 0011.34-2.24 30.53 30.53 0 009.52-6.72A39.63 39.63 0 0058.94 113a29.23 29.23 0 002.94-12.18 23.23 23.23 0 00-2.66-11.2 28.57 28.57 0 00-7.14-7.7 44.77 44.77 0 00-9.94-5.18L30.94 72a74.91 74.91 0 01-11.48-5.18 37.84 37.84 0 01-9.8-7 33 33 0 01-7-10.36A39.13 39.13 0 010 34.16a27.66 27.66 0 013.92-14.84A37.94 37.94 0 0114 8.82a47.78 47.78 0 0113.72-6.58A50.49 50.49 0 0142.7 0z"
      fill="fill"
    />
  </svg>
);

const SvgT = props => (
  <svg viewBox="0 0 71.96 140" {...props}>
    <path d="M72 6.16H37c0 44.24.14 89.6.14 133.84h-6.9l.14-133.84H0V0h72z" fill="fill" />
  </svg>
);

const SvgU = props => (
  <svg viewBox="0 0 91.57 140.14" {...props}>
    <path
      d="M91.56 98.84c.14 7-1.26 14.84-4.76 20.86v-.14c-4.76 8.26-17.22 20.72-40.6 20.58-25.06-.14-36.12-12.6-41.2-20.86s-5-18.34-5-20.16V0h6.72l-.28 99c.14 4.2.56 11.34 4.06 16.94 4.76 8 15.82 18.06 35.7 18.06 22 0 32.48-12.74 35-17.92 2.66-4.9 3.22-8.82 3.36-17.22V0h7z"
      fill="fill"
    />
  </svg>
);

const SvgV = props => (
  <svg viewBox="0 0 103.88 140" {...props}>
    <path
      d="M6.44 0L51 124C66.22 82.74 81.62 41.16 96.74 0h7.14L52.36 140h-3.22L0 0z"
      fill="fill"
    />
  </svg>
);

const SvgW = props => (
  <svg viewBox="0 0 133.42 140" {...props}>
    <path
      d="M37.66 140h-8L0 0h6.86S33 123.48 33 129.36L64 0h5.18l30.64 126.28C108.5 84.56 117.6 41.72 126.28 0h7.14l-29.54 140h-8.12L66.64 17.5z"
      fill="fill"
    />
  </svg>
);

const SvgX = props => (
  <svg viewBox="0 0 89.32 140" {...props}>
    <path
      d="M81.9 140L44.52 76C32.2 97 19.6 118.86 7.28 140H.42S34 81.76 40.6 70.14C32.48 56 6.58 11.62 0 0h7.14l37.38 64.4C56.84 43.12 69.58 21.28 81.9 0h7.42l-41 70.14L89.18 140z"
      fill="fill"
    />
  </svg>
);

const SvgY = props => (
  <svg viewBox="0 0 78.12 140" {...props}>
    <path
      d="M10.92 140l28.42-67.9C26.32 48.3 13 23.8 0 0h7l35.84 64.4C52.08 43 61.6 21.42 70.84 0h7.28L17.5 140z"
      fill="fill"
    />
  </svg>
);

const SvgZ = props => (
  <svg viewBox="0 0 76.86 140" {...props}>
    <path d="M8.82 134h64.82v6H0v-2.66L67.06 6.16H0V0h76.86z" fill="fill" />
  </svg>
);

const SVGCharacters = {
  1: Svg1,
  2: Svg2,
  3: Svg3,
  4: Svg4,
  5: Svg5,
  6: Svg6,
  7: Svg7,
  8: Svg8,
  9: Svg9,
  10: Svg10,
  11: Svg11,
  12: Svg12,
  13: Svg13,
  14: Svg14,
  15: Svg15,
  16: Svg16,
  17: Svg17,
  18: Svg18,
  19: Svg19,
  20: Svg20,
  A: SvgA,
  B: SvgB,
  C: SvgC,
  D: SvgD,
  E: SvgE,
  F: SvgF,
  G: SvgG,
  H: SvgH,
  I: SvgI,
  J: SvgJ,
  K: SvgK,
  L: SvgL,
  M: SvgM,
  N: SvgN,
  O: SvgO,
  P: SvgP,
  Q: SvgQ,
  R: SvgR,
  S: SvgS,
  T: SvgT,
  U: SvgU,
  V: SvgV,
  W: SvgW,
  X: SvgX,
  Y: SvgY,
  Z: SvgZ
};
Object.freeze(SVGCharacters);
export default SVGCharacters;
